import React, { useContext } from 'react'; 
import { Row, Col } from 'react-bootstrap';
import { numberFormatter } from '../../components/formatters/numberFormatter';
import { toWords } from 'number-to-words';
import { DataContext } from '../../init/getData';
import ReceiptVoucher from './receiptPrint';

const ComponentToPrint = React.forwardRef((props, ref) => {
  const {
    journalVoucher,
    vatAmount,
    mainCurrency,
    secondaryCurrency,
    secondaryVatAmount,
    totalBeforeVat,
    secondaryTotalBeforeVat
  } = props;

  const { settingData } = useContext(DataContext);

  // ✅ if it's a Receipt, just return ReceiptVoucher
  if (journalVoucher?.type === 'Receipt') {
    return (
      <ReceiptVoucher
        ref={ref}
        journalVoucher={journalVoucher}
        vatAmount={vatAmount}
        mainCurrency={mainCurrency}
        secondaryCurrency={secondaryCurrency}
        secondaryVatAmount={secondaryVatAmount}
      />
    );
  }

  let cartColumns;

  const costTypes = ['PurchaseInvoice', 'PurchaseReturn', 'PurchaseOrder'];

  

  if (costTypes.includes(journalVoucher?.type)) {
    cartColumns = [
      {
        title: 'Product',
        dataIndex: 'product',
        width: 200,
        render: (product) => product?.name,
      },
      ...(settingData.quantityPrint
        ? [{ title: 'Quantity', dataIndex: 'quantity', render: numberFormatter }]
        : []),
      { title: 'FreeQuantity', dataIndex: 'freeQuantity', render: numberFormatter },
      ...(settingData.netQuantityPrint
        ? [{ title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter }]
        : []),
      { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetCost', dataIndex: 'netCost', render: numberFormatter },
      ...(settingData.vatPrint
        ? [{ title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter }]
        : []),
    ];
  } else {
    cartColumns = [
      {
        title: 'Product',
        dataIndex: 'product',
        width: 200,
        render: (product) => product?.name,
      },
      ...(settingData.unitsPrint
        ? [{
            title: 'Unit',
            dataIndex: 'unitName',
            render: (unitName, record) => unitName + ' (' + record.unitQuantity + ')',
          }]
        : []),
      ...(settingData.itemPricePrint
        ? [{ title: 'Price', dataIndex: 'price', render: numberFormatter }]
        : []),
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      ...(settingData.netQuantityPrint
        ? [{ title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter }]
        : []),
      ...(settingData.netPricePrint
        ? [{ title: 'NetPrice', dataIndex: 'netPrice', render: numberFormatter }]
        : []),
      ...(settingData.quantityPrint
        ? [{ title: 'Quantity', dataIndex: 'netQuantity', render: numberFormatter }]
        : []),
      ...(settingData.totalPricePrint
        ? [{ title: 'TotalPrice', dataIndex: 'totalPrice', render: numberFormatter }]
        : []),
      ...(settingData.vatPrint
        ? [{ title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter }]
        : []),
    ];
  }

  // Check if it's a Receipt type
  const isReceipt = journalVoucher?.type === 'Receipt';

  const boxStyle = {
    border: isReceipt ? 'none' : '1px solid #000',
    padding: '15px',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const sectionContainerStyle = {
    display: 'flex',
    marginBottom: '20px',
    gap: '20px',
  };

  const infoTextStyle = {
    margin: '5px 0 0 0',
  };

  // Calculate how many empty rows we need to add to fill the space
  const cartItems = journalVoucher?.cart || [];
  const emptyRowsCount = Math.max(0, 10 - cartItems.length); // Add empty rows to make at least 10 rows total

  // Split items into chunks of 15 rows
    const chunkArray = (arr, size) => {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    };

    const paginatedItems = chunkArray(cartItems, 15);




  return (

    
    
    <div 
      ref={ref} 
      style={{ 
        padding: '30px', 
        fontFamily: 'Arial, sans-serif', 
        color: '#333', 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      {/* Header - Matching ReceiptVoucher style */}
      <div style={{ marginBottom: "30px", borderBottom: "2px solid #ddd", paddingBottom: "20px" }}>
        <Row>
          {/* LEFT SIDE */}
          <Col md={7}>
            <h2 style={{ fontWeight: "bold", fontSize: "1.4rem", margin: "0 0 8px 0" }}>
              {journalVoucher?.company?.name}
            </h2>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Reg:</strong>
              {journalVoucher?.company?.registrationNumber}
            </p>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Address:</strong>
              {journalVoucher?.company?.address}
            </p>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Phone:</strong>
              {journalVoucher?.company?.phone}
            </p>
          </Col>

          {/* RIGHT SIDE */}
          <Col md={5} style={{ textAlign: "right" }}>
            <div style={{ textAlign: "left", display: "inline-block" }}>
              <h2 style={{ fontSize: "1.4rem", margin: "0 0 15px 0", fontWeight: "bold" }}>
                {journalVoucher?.type === 'Receipt'
                  ? 'RECEIPT'
                  : journalVoucher?.type === 'Payment'
                  ? 'PAYMENT'
                  : journalVoucher?.type === 'PosOrder'
                  ? 'ORDER'
                  : 'INVOICE'}
              </h2>

              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>ID:</strong>
                {journalVoucher?.myId}
              </p>
              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>Ref:</strong>
                {journalVoucher?.id}
              </p>
              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>Date:</strong>
                {journalVoucher?.date}
              </p>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
             <strong style={{ display: "inline-block", width: "70px" }}>Currency:</strong>{' '}
              {mainCurrency?.code}

            </p>
              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>Rate:</strong>
                {numberFormatter(journalVoucher?.currency?.rate)}{' '}{secondaryCurrency?.symbol}
              </p>
            </div>
          </Col>
        </Row>
      </div>

       <div style={{ marginTop: "2px"}}>
          <div
            style={{
              border: "1px solid #ccc",
              borderRadius: "0px",
              padding: "15px 15px",
              backgroundColor: "transparent",
            }}
          >
            <Row>
              <Col md={6}>
                <div style={{ padding: "10px", border: "none" }}>
                  <h3
                    style={{
                      fontSize: "1rem",
                      margin: "0 0 7px 0",
                      fontWeight: "bold",
                    }}
                  >
                    Billed To:
                  </h3>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Name:</strong> {journalVoucher?.account?.english}
                  </p>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Reg:</strong> {journalVoucher?.account?.registration}
                  </p>
                </div>
              </Col>

              <Col md={6}>
                <div
                  style={{
                    padding: "10px",
                    border: "none",
                    textAlign: "right",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1rem",
                      margin: "0 0 7px 0",
                      fontWeight: "bold",
                      visibility: "hidden", // keeps vertical alignment
                    }}
                  >
                    Billed To:
                  </h3>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Address:</strong> {journalVoucher?.account?.address}
                  </p>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Phone:</strong> {journalVoucher?.account?.phone}
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>


      {/* Table Section - Only show if it's not a Receipt or if there are cart items */}
      {/* Table Section - Only show if it's not a Receipt */}
{!isReceipt && cartItems.length > 0 && (
  <>
    {paginatedItems.map((pageItems, pageIndex) => (
      <div
        key={pageIndex}
        style={{
          padding: '0',
          fontFamily: 'Arial, sans-serif',
          color: '#333',
          minHeight: '400px',
          pageBreakAfter: pageIndex === paginatedItems.length - 1 ? 'auto' : 'always',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '15px',
            fontSize: '14px',
          }}
          border="1"
        >
          <thead>
            <tr>
              {cartColumns.map((col, index) => (
                <th
                  key={index}
                  style={{
                    padding: '12px 8px',
                    border: '1px solid #000',
                    textAlign: 'left',
                  }}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {pageItems.map((item, rowIndex) => (
              <tr key={rowIndex}>
                {cartColumns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      padding: '8px',
                      border: '1px solid #000',
                      verticalAlign: 'top',
                    }}
                  >
                    {col.render
                      ? col.render(item[col.dataIndex], item)
                      : item[col.dataIndex]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>

          {/* Only show tfoot on last page */}
          {pageIndex === paginatedItems.length - 1 && (
            <tfoot>
              <tr>
                <td
                  rowSpan="4"
                  colSpan={cartColumns.length - 5}
                  style={{
                    border: '1px solid #000',
                    borderRight: 'none',
                    padding: '8px',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ margin: '0' }}>
                    <strong>Only:</strong> {toWords(journalVoucher?.totalDebit)}
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={5} style={{ border: '1px solid #000', padding: '8px' }}>
                  <strong>Total Before Vat:</strong>&nbsp;
                  {numberFormatter(totalBeforeVat)} {mainCurrency?.symbol} &nbsp;&nbsp;
                  {numberFormatter(secondaryTotalBeforeVat)} {secondaryCurrency?.symbol}
                </td>
              </tr>
              <tr>
                <td colSpan={5} style={{ border: '1px solid #000', padding: '8px' }}>
                  <strong>VAT:</strong>&nbsp;
                  {numberFormatter(vatAmount)} {mainCurrency?.symbol} &nbsp;&nbsp;
                  {numberFormatter(secondaryVatAmount)} {secondaryCurrency?.symbol}
                </td>
              </tr>
              <tr>
                <td colSpan={5} style={{ border: '1px solid #000', padding: '8px' }}>
                  <strong>Total price:</strong>&nbsp;
                  {numberFormatter(journalVoucher?.totalDebit)} {mainCurrency?.symbol} &nbsp;&nbsp;
                  {numberFormatter(journalVoucher?.secondaryTotalDebit)} {secondaryCurrency?.symbol}
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    ))}
  </>
)}


    

      {/* Spacer */}
      <div style={{ marginTop: '20px', minHeight: '40px' }} />
    

      {/* Footer Section - Appears in all cases */} 
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          paddingTop: "8px",
          background: "#fff",
        }}
      >
        <Row>
          <Col md={4} style={{ textAlign: "center", color: "#000" }}>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>Receiver Signature:</p>
            <p style={{ margin: "25px 0 5px 0" }}>_________________________</p>
          </Col>
          <Col md={4} style={{ textAlign: "center", color: "#000" }}>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>Sales Signature:</p>
            <p style={{ margin: "25px 0 5px 0" }}>_________________________</p>
          </Col>
          <Col md={4} style={{ textAlign: "center", color: "#000" }}>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>Accountant:</p>
            <p style={{ margin: "25px 0 5px 0" }}>_________________________</p>
          </Col>
        </Row>
      </div>
    </div>
  );
});

export default ComponentToPrint;